import React from 'react'
import { Main, ViewButton } from 'components/ActionStyles/ActionStyles'
import { useNavigate } from 'react-router'

const ViewActionDropdown = ({ instituteCampusId,candidates }) => {
  const navigate = useNavigate()

  return (
    <Main>
      <ViewButton
        onClick={() => navigate(`${instituteCampusId}/${candidates}/view-college-details`)}
        height="32px"
        text={'View'}
      />
    </Main>
  )
}

export default ViewActionDropdown
